import React, { Component } from "react";

// Assets
import RecipePic from "../../Assets/recipeImg.svg";
import carbIcon from "../../Assets/blueCarbs.svg";
import timeIcon from "../../Assets/blueClock.svg";
import peopleIcon from "../../Assets/bluePeople.svg";

// FoodRecipe Component
export default class RecipeDetails extends Component {
  render() {
    return (
      <div className="FoodSection_RecipeBlock">
        <div className="FoodSection_RecipeDetailsBlock">
          <div className="FoodSection_RecipeImage">
            <img src={RecipePic} alt="Recipe Image" />
          </div>
          <div className="FoodSection_RecipeBlockCard">
            <div className="FoodSection_RecipeName">Chapati</div>
            <div className="FoodSection_RecipeTitle">Recipe</div>
            <div className="FoodSection_RHolder">
              <div className="FoodSection_RecipeList">
                <div className="FoodSection_RecipeData">
                  Clean 2 cup of poha and add them to a large colander, straign
                  or bowl or pot. Please Note that to make not sticky poha,you
                  will need to use thick or medium flakes. If you use flakes
                  poha will turn mushy after rising them
                </div>
                <div className="FoodSection_RecipeData">
                  Clean 2 cup of poha and add them to a large colander, straign
                  or bowl or pot. Please Note that to make not sticky poha,you
                  will need to use thick or medium flakes. If you use flakes
                  poha will turn mushy after rising them
                </div>
                <div className="FoodSection_RecipeData">
                  Clean 2 cup of poha and add them to a large colander, straign
                  or bowl or pot. Please Note that to make not sticky poha,you
                  will need to use thick or medium flakes. If you use flakes
                  poha will turn mushy after rising them
                </div>
                <div className="FoodSection_RecipeData">
                  Clean 2 cup of poha and add them to a large colander, straign
                  or bowl or pot. Please Note that to make not sticky poha,you
                  will need to use thick or medium flakes. If you use flakes
                  poha will turn mushy after rising them
                </div>
                <div className="FoodSection_RecipeData">
                  Clean 2 cup of poha and add them to a large colander, straign
                  or bowl or pot. Please Note that to make not sticky poha,you
                  will need to use thick or medium flakes. If you use flakes
                  poha will turn mushy after rising them
                </div>
                <div className="FoodSection_RecipeData">
                  Clean 2 cup of poha and add them to a large colander, straign
                  or bowl or pot. Please Note that to make not sticky poha,you
                  will need to use thick or medium flakes. If you use flakes
                  poha will turn mushy after rising them
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="FoodSection_IngredientContainer">
          <div className="FoodSection_IngredientBlock">
            <div className="FoodSection_RecipePara">
              <div className="FoodSection_Data">
                <img
                  className="FoodSection_Icon"
                  src={carbIcon}
                  alt="Carbohydrate Image"
                />
                <div className="FoodSection_CarbsData">70 gm</div>
              </div>
              <div className="FoodSection_Data">
                <img
                  className="FoodSection_Icon"
                  src={timeIcon}
                  alt="Carbohydrate Image"
                />
                <div className="FoodSection_CarbsData">70 gm</div>
              </div>
              <div className="FoodSection_Data">
                <img
                  className="FoodSection_Icon"
                  src={peopleIcon}
                  alt="Carbohydrate Image"
                />
                <div className="FoodSection_CarbsData">70 gm</div>
              </div>
            </div>
            <div className="FoodSection_IngredientTitle">Ingredients</div>
            <div className="FoodSection_IngredientHolder">
              <div className="FoodSection_IngredientList">
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
                <div className="FoodSection_Ingredient">Ingredient 1</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
